import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=2e7e48b1&scoped=true&"
import script from "./Detailed.vue?vue&type=script&lang=js&"
export * from "./Detailed.vue?vue&type=script&lang=js&"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=2e7e48b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7e48b1",
  null
  
)

export default component.exports